module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M16.75 4.16699C16.75 3.66073 16.3393 3.25 15.833 3.25H4.16699C3.66073 3.25 3.25 3.66073 3.25 4.16699V15.833C3.25 16.3393 3.66073 16.75 4.16699 16.75H15.833C16.3393 16.75 16.75 16.3393 16.75 15.833V4.16699ZM18.25 15.833C18.25 17.1677 17.1677 18.25 15.833 18.25H4.16699C2.8323 18.25 1.75 17.1677 1.75 15.833V4.16699C1.75 2.8323 2.8323 1.75 4.16699 1.75H15.833C17.1677 1.75 18.25 2.8323 18.25 4.16699V15.833Z\" fill=\"currentColor\"/><path d=\"M8.41638 7.49902C8.41638 6.99287 8.00648 6.58221 7.50037 6.58203 6.99411 6.58203 6.58337 6.99276 6.58337 7.49902 6.58355 8.00513 6.99421 8.41504 7.50037 8.41504 8.00637 8.41486 8.41621 8.00503 8.41638 7.49902zM9.91638 7.49902C9.91621 8.83345 8.8348 9.91486 7.50037 9.91504 6.16579 9.91504 5.08355 8.83356 5.08337 7.49902 5.08337 6.16434 6.16568 5.08203 7.50037 5.08203 8.8349 5.08221 9.91638 6.16444 9.91638 7.49902zM13.75 8.69141C14.3909 8.69141 15.0058 8.94636 15.459 9.39941L18.0303 11.9707 18.0821 12.0273C18.3224 12.3219 18.3049 12.7566 18.0303 13.0312 17.7557 13.3059 17.321 13.3233 17.0264 13.083L16.9698 13.0312 14.3985 10.46C14.2266 10.2881 13.9931 10.1914 13.75 10.1914 13.5374 10.1914 13.3321 10.2649 13.169 10.3984L13.1016 10.46 5.53032 18.0312C5.23743 18.3241 4.76267 18.3241 4.46977 18.0312 4.17692 17.7384 4.17689 17.2636 4.46977 16.9707L12.0411 9.39941 12.2188 9.23828C12.6488 8.88613 13.1894 8.69141 13.75 8.69141z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
